import { MenuDivider } from 'lib_ui-primitives';
export default MenuDivider;
